import { ExternalLink, Database } from "lucide-react";

const fmt = (v) => (v === null || v === undefined || v === "" ? "—" : typeof v === "number" ? v.toLocaleString() : String(v));
const head = (k) => k.replace(/_/g, " ");

const EvidenceTable = ({ ev, i }) => {
  const cols = ev.rows.length ? Object.keys(ev.rows[0]).filter((c) => !(ev.link === "lead" && c === "id")) : [];
  return (
    <div style={{ overflowX: "auto", marginTop: 8, maxWidth: "100%" }}>
      <table className="table" style={{ fontSize: 12, width: "auto", minWidth: "100%" }} data-testid={`ai2-evidence-table-${i}`}>
        <thead><tr>{cols.map((c) => <th key={c} style={{ textAlign: "left", whiteSpace: "nowrap" }}>{head(c)}</th>)}</tr></thead>
        <tbody>
          {ev.rows.map((r, j) => (
            <tr key={j} style={{ background: j % 2 ? "#F5F9F9" : undefined }}>
              {cols.map((c) => (
                <td key={c} className={typeof r[c] === "number" ? "mono" : undefined} style={{ whiteSpace: "nowrap" }}>
                  {ev.link === "lead" && c === "name" ? (
                    <a href={`/leads/${r.id}`} target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 4, fontWeight: 700, textDecoration: "none" }} data-testid={`ai2-evidence-lead-${i}-${j}`}>{r.name}<ExternalLink size={11} /></a>
                  ) : c === "revenue" && typeof r[c] === "number" ? `$${r[c].toLocaleString()}` : fmt(r[c])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const Evidence = ({ msg }) => {
  const ev = msg?.evidence || [];
  if (!ev.length) return <div className="muted" style={{ fontSize: 13 }} data-testid="ai2-evidence-empty">This answer didn't use any live data lookups.</div>;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14, minWidth: 0 }} data-testid="ai2-evidence">
      {ev.map((e, i) => (
        <div key={i} style={{ borderBottom: "1px solid var(--divider)", paddingBottom: 12 }} data-testid={`ai2-evidence-${i}`}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, fontWeight: 700 }}><Database size={13} color="#1F8A7C" />{e.label}</div>
          <div className="muted mono" style={{ fontSize: 11, marginTop: 4 }}>
            {e.location}{Object.entries(e.params || {}).filter(([, v]) => v !== "" && v !== null && v !== undefined && typeof v !== "object").map(([k, v]) => ` · ${head(k)}: ${v}`).join("")} · {e.row_count} record{e.row_count === 1 ? "" : "s"}
          </div>
          {e.rows?.length > 0 && <EvidenceTable ev={e} i={i} />}
          {e.row_count > (e.rows?.length || 0) && <div className="muted" style={{ fontSize: 11, marginTop: 4 }}>Showing first {e.rows.length} of {e.row_count}.</div>}
        </div>
      ))}
    </div>
  );
};
